module.exports = __webpack_public_path__ + "media/celebrate.03371af1.svg";